import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetActiveCompositionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveCompositionQuery = { __typename?: 'Query', activeComposition?: { __typename?: 'AfterEffectsComposition', id?: string | null, name?: string | null } | null };


export const GetActiveComposition = /*#__PURE__*/ gql`
    query GetActiveComposition {
  activeComposition {
    id
    name
  }
}
    ` as unknown as DocumentNode<GetActiveCompositionQuery, GetActiveCompositionQueryVariables>;

          

          export const useGetActiveCompositionQuery = (options?:QueryHookOptions<GetActiveCompositionQuery, GetActiveCompositionQueryVariables>) => useQuery(GetActiveComposition, options);

          

          export type GetActiveCompositionQueryOptions = QueryHookOptions<GetActiveCompositionQuery, GetActiveCompositionQueryVariables>;

          

          export const useGetActiveCompositionLazyQuery = (options?:LazyQueryHookOptions<GetActiveCompositionQuery, GetActiveCompositionQueryVariables>) => useLazyQuery(GetActiveComposition, options);

          

          export type GetActiveCompositionQueryResult = ReturnType<typeof useGetActiveCompositionQuery>;

          
